import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { EventCard } from "@/components/EventCard";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MyList({ mode }) {
  const { user, loading, login } = useAuth();
  const [events, setEvents] = useState([]);
  const path = mode === "saved" ? "/me/saved" : "/me/rsvps";
  const title = mode === "saved" ? "Saved events" : "My RSVPs";

  useEffect(() => {
    if (!user) return;
    apiFetch(path).then(setEvents).catch(() => setEvents([]));
  }, [user, path]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-testid="mylist-title">
          {title}
        </h1>
        {!user && !loading ? (
          <div className="mt-8 rounded-2xl border border-dashed border-neutral-300 p-14 text-center">
            <p className="text-base font-semibold text-neutral-900">Sign in to see this list</p>
            <button
              onClick={login}
              data-testid="mylist-login"
              className="mt-4 rounded-full bg-neutral-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-neutral-700"
            >
              Continue with Google
            </button>
          </div>
        ) : events.length === 0 ? (
          <p className="mt-6 text-sm text-neutral-500" data-testid="mylist-empty">
            Nothing here yet.
          </p>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-8" data-testid="mylist-grid">
            {events.map((e, i) => (
              <EventCard
                key={e.event_id}
                event={e}
                index={i}
                onChange={(u) => setEvents((prev) => prev.map((p) => (p.event_id === u.event_id ? u : p)))}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
